import script from "./NewGitCom.vue?vue&type=script&setup=true&lang=js"
export * from "./NewGitCom.vue?vue&type=script&setup=true&lang=js"

import "./NewGitCom.vue?vue&type=style&index=0&id=3dfbf579&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3dfbf579"]])

export default __exports__